import { Component, OnInit } from '@angular/core';
import { ProductListConfiguration } from '../../../_components/product-list/product-list.configuration';
import { ProductCategoryMacroTypeEnum } from '../../../core/enums/product-category-macro-type.enum';
import { CtAuthenticationService } from '@ctsolution/ct-authentication';

@Component({
  selector: 'app-subscriptions-list',
  templateUrl: './subscriptions-list.component.html',
  styleUrls: ['./subscriptions-list.component.scss'],
})
export class SubscriptionsListComponent implements OnInit {

  subscriptions: ProductListConfiguration = ProductListConfiguration.create(ProductCategoryMacroTypeEnum.Subscription);

  constructor(private authService: CtAuthenticationService) {
  }

  async ngOnInit(): Promise<void> {
    // Forza il reload dei claims JWT per avere i dati aggiornati (es. stato pagamento)
    await this.authService.getClaims();
  }

}
